// Note: Same keys are being used as copy keys
export const offerSortingOptions = [
  "offersSortPriceLowToHigh",
  "offersSortDeliveryFastToSlow",
];
